import React from 'react';
import './AboutVenueDetails.css';
import { FaLocationDot } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa6";
import { MdOutlineMail } from "react-icons/md";
export default function AboutVenueDetails({ data }) {

  console.log("data", data);
  return (
    <div className="venue-about-container">
      <h1 className="venue-heading">About</h1>

      <div className="highlight-section">
        <h6>About The {data?.name}</h6>
        <p className='about-venue'> {data?.about?.description || "The Grand Sapphire Hall is a premier event venue located in the heart of Delhi. Known for its luxurious interiors, elegant ambiance, and top-notch services, it is the perfect location for weddings, corporate events, receptions, and social gatherings."}</p>
      </div>
      <hr />

      <div className="highlight-section">
        <h6>Highlights</h6>
        <div className='highlight-venue-section'>
          <div className='highlight-venue-features'>
            <p>Capacity : Up to 500 guest</p>
            <p>Valet Parking Available</p>
            <p>In-house Catering & DJ</p>
          </div>
          <div className='highlight-venue-features'>
            <p>Dedicated Bridal Room</p>
            <p>Air Conditioned Banquet Halls</p>
          </div>
        </div>
      </div>
      <hr />
      <div className="highlight-section">
        <h6>Venue Features</h6>
        <div className='highlight-venue-section'>
          <div className='highlight-venue-features'>
            <p>Stage Setup</p>
            <p>Led Screens</p>
            <p>Lawn + Indoor Halls</p>
          </div>
          <div className='highlight-venue-features'>
            <p>Custom Decor</p>
            <p>Live counters</p>
          </div>
        </div>
      </div>

      <hr />

    </div>
  );
}
